import { ThemeProvider } from "@emotion/react";
import { legionTheme } from "@legion-ui/core";
import ColorsCard from "../../../../src/components/CardColor/CardColor.jsx";
import * as React from 'react';
export default {
  ThemeProvider,
  legionTheme,
  ColorsCard,
  React
};